import React, { useContext } from 'react'
import { AppConfigContext } from '../../../../../context/AppConfig'
import { getPackageName, isStagedWithCortPackage } from '../../../../../helpers/packages'

function TVDesignPicker({ className = '', packages, onPackageSelected, selectedPackage }) {
  const containerRef = React.useRef(null)
  const isDragging = React.useRef(false)
  const startX = React.useRef(0)
  const scrollLeft = React.useRef(0)
  const moved = React.useRef(false) // track if mouse moved

  React.useEffect(() => {
    const container = containerRef.current
    if (!container) return

    const onWheel = (e) => {
      if (e.deltaY !== 0) {
        e.preventDefault()
        container.scrollLeft += e.deltaY
      }
    }

    container.addEventListener('wheel', onWheel, { passive: false })
    return () => container.removeEventListener('wheel', onWheel)
  }, [])

  React.useEffect(() => {
    const container = containerRef.current
    if (!container) return

    const onMouseDown = (e) => {
      isDragging.current = true
      moved.current = false
      startX.current = e.pageX - container.offsetLeft
      scrollLeft.current = container.scrollLeft
      container.style.cursor = 'grabbing'
    }

    const onMouseLeave = () => {
      isDragging.current = false
      container.style.cursor = ''
    }

    const onMouseUp = () => {
      isDragging.current = false
      setTimeout(() => { moved.current = false }, 0) // reset after click event cycle
      container.style.cursor = ''
    }

    const onMouseMove = (e) => {
      if (!isDragging.current) return
      e.preventDefault()
      moved.current = true
      const x = e.pageX - container.offsetLeft
      const walk = (x - startX.current) * 1
      container.scrollLeft = scrollLeft.current - walk
    }

    container.addEventListener('mousedown', onMouseDown)
    container.addEventListener('mouseleave', onMouseLeave)
    container.addEventListener('mouseup', onMouseUp)
    container.addEventListener('mousemove', onMouseMove)

    return () => {
      container.removeEventListener('mousedown', onMouseDown)
      container.removeEventListener('mouseleave', onMouseLeave)
      container.removeEventListener('mouseup', onMouseUp)
      container.removeEventListener('mousemove', onMouseMove)
    }
  }, [])

  const handleClick = (pack, e) => {
    if (moved.current) {
      e.preventDefault()
      e.stopPropagation()
      return
    }
    onPackageSelected(pack)
  }

  const { as_staging } = useContext(AppConfigContext)

  return (
    <div
      ref={containerRef}
      className={`${className} rounded-[4px] ${as_staging ? 'max-w-[calc(100%-182px)]' : 'max-w-[calc(100%-400px)]'} overflow-x-auto select-none`}
      style={{
        msOverflowStyle: 'none',
        scrollbarWidth: 'none',
        cursor: 'grab',
      }}
    >
      <div
        className="flex items-center bg-green rounded-[4px] h-[64px] min-w-max"
        style={{ overflow: 'hidden' }}
      >
        {packages.map((pack) => (
          <button
            key={pack.id}
            type="button"
            onClick={(e) => handleClick(pack, e)}
            className={isStagedWithCortPackage(pack) ? 'bg-[#DA2F3C] text-white rounded-full px-3' : `${
              selectedPackage && selectedPackage.id === pack.id
                ? 'bg-white text-[var(--brand-color)]'
                : 'opacity-[80%] bg-white'
            } p-4 cursor-pointer`}
          >
            <div className="text-4xl p-4">{getPackageName(pack)}</div>
          </button>
        ))}
      </div>
      <style>{`
        div::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  )
}

export default TVDesignPicker